import { Navigate } from 'react-router-dom';

function Main() {
  // window.location.hostname === 'localhost' ? <Book /> : <ComingSoon />;
  return <Navigate to="/book" />;
}

export default Main;